import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { 
  BarChart3, 
  Target, 
  TrendingUp, 
  Users, 
  PenTool,
  ChevronDown
} from 'lucide-react';

interface AgentSelectorProps {
  currentAgent: string;
  onAgentChange: (agent: string) => void;
}

const AGENTS = {
  data: { name: 'Analytics Agent', icon: BarChart3, color: 'text-blue-600', available: true },
  marketing: { name: 'Marketing Advisor', icon: Target, color: 'text-green-600', available: false },
  strategy: { name: 'Strategy Consultant', icon: TrendingUp, color: 'text-purple-600', available: false },
  persona: { name: 'Persona Expert', icon: Users, color: 'text-pink-600', available: false },
  content: { name: 'Content Specialist', icon: PenTool, color: 'text-orange-600', available: false }
};

export function AgentSelector({ currentAgent, onAgentChange }: AgentSelectorProps) {
  const [isOpen, setIsOpen] = useState(false);
  const agent = AGENTS[currentAgent as keyof typeof AGENTS] || AGENTS.data;
  const Icon = agent.icon;

  return (
    <div className="relative">
      <Button
        variant="outline"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2"
      >
        <Icon className={`w-4 h-4 ${agent.color}`} />
        <span>{agent.name}</span>
        <ChevronDown className="w-4 h-4" />
      </Button>

      {isOpen && (
        <div className="absolute top-full left-0 mt-1 w-56 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
          <div className="p-2">
            {Object.entries(AGENTS).map(([key, value]) => {
              const AgentIcon = value.icon;
              return (
                <button
                  key={key}
                  onClick={() => {
                    if (value.available) {
                      onAgentChange(key);
                      setIsOpen(false);
                    }
                  }}
                  disabled={!value.available}
                  className={`w-full flex items-center px-3 py-2 text-sm text-left rounded-md ${
                    value.available 
                      ? 'hover:bg-gray-50 cursor-pointer' 
                      : 'opacity-50 cursor-not-allowed'
                  }`}
                >
                  <AgentIcon className={`w-4 h-4 mr-2 ${value.available ? value.color : 'text-gray-400'}`} />
                  <span className={value.available ? '' : 'text-gray-400'}>
                    {value.name}
                    {!value.available && (
                      <span className="text-xs text-yellow-600 ml-1">(Coming Soon)</span>
                    )}
                  </span>
                  {key === currentAgent && (
                    <div className="w-2 h-2 bg-blue-600 rounded-full ml-auto" />
                  )}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}